// Кому что показывать. Две РАЗНЫЕ вещи, которые легко слить в одну:
//
//   visible — фича вообще есть, кнопке место на экране;
//   ready   — этот человек может запустить проверку прямо сейчас.
//
// Гостю на витрине кнопка нужна (демо-поездка показывает, что умеет продукт),
// а проверка — нет: она стоит денег и живёт на аккаунте. Отсюда и раздвоение.
//
// Чистая функция без React — компонентам остаётся только прочитать ответ.

/**
 * Чем кончился запрос `/api/prices/config`. Гостю сервер отвечает `200` с
 * одним полем `enabled` (server/prices/routes.mjs), поэтому гадать по коду
 * отказа больше не нужно: `ok` приходит и гостю тоже.
 */
export type ConfigProbe = 'loading' | 'ok' | 'failed';

export interface Availability {
  visible: boolean;
  ready: boolean;
}

/**
 * `enabled` имеет смысл только при `probe === 'ok'` — в остальных случаях
 * конфига у нас на руках нет.
 *
 * Гость с `enabled: true` — главный случай, ради которого всё раздвоено:
 * кнопку видно (демо-поездка витрины показывает, что умеет продукт),
 * запускать нечего (проверка живёт на аккаунте).
 *
 * Молчание (`loading`) и сбой (`failed`) не показывают ничего: мигнуть
 * кнопкой, чтобы через миг её убрать, хуже, чем не мигать. Догадок здесь
 * больше нет — выключенную в админке фичу гость честно не увидит.
 */
export function availability(
  probe: ConfigProbe,
  enabled: boolean,
  isGuest: boolean,
): Availability {
  if (probe !== 'ok') return { visible: false, ready: false };
  return { visible: enabled, ready: enabled && !isGuest };
}
